<h2>Реферальные кампании</h2>

<div class="container referral-campaign-content">
  <div class="referral-campaign-data">
    <div class="referral-period-filter">
      <app-date-filter (dateFilter)="changeDateFilter($event)"></app-date-filter>
      <mat-checkbox
        [checked]="referredInPeriodOnly"
        (change)="changeReferredInPeriodOnly($event.checked)">
        Только приведённые в выбранном периоде
      </mat-checkbox>
    </div>

    <p *ngIf="summaryError" role="alert">{{summaryError}} <button mat-button (click)="refresh()">Повторить</button></p>
    <div class="referral-income-stat">
      <div class="header-nav">
        <h3>Доход: </h3>
        <a [routerLink]="['../ref-income-log']">История начислений</a>
      </div>
      <div class="common-referral-stats">
        <div class="box">
          <span class="text"
                matTooltip="Весь уже перенесённый доход по кампаниям: текущий, на модерации и выведенный. Прогноз циклов показывается отдельно."
                matTooltipPosition="above">Общий</span>
          <mat-divider></mat-divider>
          <span class="number"
                matTooltip="{{referralIncomeStat?.total | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
          >{{ referralIncomeStat?.total / 100 || 0 | number : '1.2-2' }}</span>
        </div>
        <div class="box">
          <span class="text"
                matTooltip="Доступный после месячного переноса нетто-доход. Может быть отрицательным; перед модерацией или выводом долги сводятся между кампаниями владельца."
                matTooltipPosition="above">Текущий</span>
          <mat-divider></mat-divider>
          <span class="number"
                matTooltip="{{referralIncomeStat?.rewardCoins | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
          >{{ referralIncomeStat?.rewardCoins / 100 || 0 | number : '1.2-2' }}</span>
        </div>
        <div class="box">
          <span class="text"
                matTooltip="Положительный перенесённый доход, ожидающий существующей модерации. При выводе учитывается общий долг владельца по всем кампаниям."
                matTooltipPosition="above">На модерации</span>
          <mat-divider></mat-divider>
          <span class="number"
                matTooltip="{{referralIncomeStat?.rewardCoinsModerated | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
          >{{ referralIncomeStat?.rewardCoinsModerated / 100 || 0 | number : '1.2-2' }}</span>
        </div>
        <div class="box">
          <span class="text"
                matTooltip="Доход, уже переведённый на REAL-баланс рефовода."
                matTooltipPosition="above">Выведено</span>
          <mat-divider></mat-divider>
          <span class="number"
                matTooltip="{{referralIncomeStat?.rewardCoinsTaken | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
          >{{ referralIncomeStat?.rewardCoinsTaken / 100 || 0 | number : '1.2-2' }}</span>
        </div>
        <div class="box">
          <span class="text"
                matTooltip="Рассчитанные, но ещё не перенесённые результаты плюс оценка активных циклов. Информационная сумма, недоступная к выводу до месячного начисления."
                matTooltipPosition="above">Прогноз циклов</span>
          <mat-divider></mat-divider>
          <span class="number"
                [ngClass]="{ red: referralIncomeStat?.forecastRewardCoins < 0 }"
                matTooltip="Пересчитан: {{ referralIncomeStat?.forecastCalculatedAt ? (referralIncomeStat?.forecastCalculatedAt | date: 'dd.MM.yy HH:mm') : '—' }}"
                matTooltipPosition="above"
          >{{ referralIncomeStat?.forecastRewardCoins / 100 || 0 | number : '1.2-2' }}</span>
        </div>
      </div>
      <div class="income-actions">
        <button mat-stroked-button color="warn" (click)="forceWithdrawReferralIncome()"
                matTooltip="Принудительно свести долги по всем кампаниям, перенести положительный текущий доход и сумму на модерации в выведенный доход и зачислить остаток на REAL-баланс"
                matTooltipPosition="above">Забрать доход</button>
      </div>
    </div>

    <mat-divider class="divider"></mat-divider>

    <div class="referral-common-stat-container">
      <h3 class="title">Статистика кампаний: </h3>
      <mat-table [dataSource]="commonStatDataSource" class="table ref-common-stat-table">

        <!-- count Column -->
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let element; let i=index">{{ i + 1 }}</mat-cell>
          <mat-footer-cell *matFooterCellDef>{{ totalStat.code }}</mat-footer-cell>
        </ng-container>

        <!-- code Column -->
        <ng-container matColumnDef="code">
          <mat-header-cell *matHeaderCellDef>Код</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="text-overflow">{{ element.code }}</span>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <!-- activations Column -->
        <ng-container matColumnDef="activations">
          <mat-header-cell *matHeaderCellDef
                           matTooltip="За период: новые привязки / события активации / новые, не активированные к концу периода / события ухода. Галочка ограничивает выборку приведёнными в периоде. Для старых активированных рефералов без даты активации используется дата привязки — приблизительно."
                           matTooltipPosition="above"
          >Рефералов
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="activations">
              <span>{{ element.total }}</span> /
              <span [ngClass]="{ green: +element.activated }">{{ element.activated }}</span> /
              <span>{{ element.notActivated }}</span> /
              <span [ngClass]="{ red: +element.lost }">{{ element.lost }}</span>
              <!-- все потому что с сервера String! !-->
            </div>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>
            <div class="activations">
              <span>{{ totalStat.total }}</span> /
              <span [ngClass]="{ green: +totalStat.activated }">{{ totalStat.activated }}</span> /
              <span>{{ totalStat.notActivated }}</span> /
              <span [ngClass]="{ red: +totalStat.lost }">{{ totalStat.lost }}</span>
            </div>
          </mat-footer-cell>
        </ng-container>

        <!-- registration Column -->
        <ng-container matColumnDef="registration">
          <mat-header-cell *matHeaderCellDef>Регистраций</mat-header-cell>
          <mat-cell *matCellDef="let element"><span>{{ element.registered }} шт.</span></mat-cell>
          <mat-footer-cell *matFooterCellDef>{{ totalStat.registered }} шт.</mat-footer-cell>
        </ng-container>

        <!-- deposits Column -->
        <ng-container matColumnDef="deposits">
          <mat-header-cell *matHeaderCellDef>Депозитов</mat-header-cell>
          <mat-cell *matCellDef="let element">
                          <span
                            matTooltip="{{element?.deposit | fastCoinsToDollar}}"
                            matTooltipPosition="above"
                            [matTooltipDisabled]="!isGoFast"
                          >  {{ element.deposit / 100 || 0 }}
              </span>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>
               <span
                 matTooltip="{{totalStat?.deposit | fastCoinsToDollar}}"
                 matTooltipPosition="above"
                 [matTooltipDisabled]="!isGoFast"
               >  {{ totalStat.deposit / 100 | number }}
              </span></mat-footer-cell>
        </ng-container>

        <!-- depositsCount Column -->
        <ng-container matColumnDef="depositsCount">
          <mat-header-cell *matHeaderCellDef>Кол-во депозитов</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{ element.depositCount }} шт.</span>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef>{{ totalStat.depositCount }} шт.</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="payouts">
          <mat-header-cell *matHeaderCellDef matTooltip="Чистая сумма выводов за период с учётом возвратов">Выводов</mat-header-cell>
          <mat-cell *matCellDef="let element"><span [matTooltip]="element.payouts | fastCoinsToDollar" [matTooltipDisabled]="!isGoFast">{{ element.payouts / 100 | number : '1.2-2' }}</span></mat-cell>
          <mat-footer-cell *matFooterCellDef><span [matTooltip]="totalStat.payouts | fastCoinsToDollar" [matTooltipDisabled]="!isGoFast">{{ totalStat.payouts / 100 | number : '1.2-2' }}</span></mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="delta">
          <mat-header-cell *matHeaderCellDef matTooltip="Депозиты минус чистая сумма выводов за выбранный период">Дельта</mat-header-cell>
          <mat-cell *matCellDef="let element"><span [matTooltip]="element.delta | fastCoinsToDollar" [matTooltipDisabled]="!isGoFast">{{ element.delta / 100 | number : '1.2-2' }}</span></mat-cell>
          <mat-footer-cell *matFooterCellDef><span [matTooltip]="totalStat.delta | fastCoinsToDollar" [matTooltipDisabled]="!isGoFast">{{ totalStat.delta / 100 | number : '1.2-2' }}</span></mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="commonStatColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: commonStatColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef='commonStatColumns;'></mat-footer-row>

      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </div>

    <div class="referrals-container">
      <div class="referrals-content-header">
        <h3 class="title">Рефералы кампаний: </h3>

        <div class="buttons">
          <mat-form-field appearance="outline" class="connected-referrals">
            <mat-select (selectionChange)="applyFilter($event)" [value]="selectedFilter">
              <mat-option *ngFor="let item of referralFilter" [value]="item.data">
                {{ item.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="referral-sort-field">
            <mat-label>Сортировка</mat-label>
            <mat-select (selectionChange)="applySortField($event)" [value]="selectedSortField">
              <mat-option *ngFor="let item of referralSortOptions" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="referral-sort-direction">
            <mat-label>Направление</mat-label>
            <mat-select (selectionChange)="applySortDirection($event)" [value]="selectedSortDirection">
              <mat-option *ngFor="let item of referralSortDirections" [value]="item.data">
                {{ item.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-stroked-button color="warn" (click)="resetReferralIncome(null)">Сбросить доход</button>

          <button mat-stroked-button color="warn" (click)="lockAllUserRefs()">Заблокировать всех</button>

          <button mat-stroked-button color="warn" (click)="clearReferralCampaignDebt()"
                  matTooltip="Отрицательный reward_coins кампаний → 0 (списание долга, не перенос)"
                  matTooltipPosition="above">Обнулить долг</button>
        </div>
      </div>

      <p *ngIf="listError" role="alert">{{listError}} <button mat-button (click)="changePage({pageIndex: pageIndex, pageSize: pageSize, length: referralsTotal})">Повторить</button></p>
      <mat-table [dataSource]="referralsDataSource" class="table referrals-table">
        <!-- connected Column -->
        <ng-container matColumnDef="connected">
          <mat-header-cell *matHeaderCellDef
                           matTooltip="Активирирован"
                           matTooltipPosition="above">А
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon class="sign"
                      [ngClass]="element.connected?'approve':'warn'">{{ element.connected ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </mat-cell>
        </ng-container>

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Имя</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="text-overflow"><a [routerLink]="['/user/', element.id]">{{ element.name }}</a></span>
          </mat-cell>
        </ng-container>

        <!-- date_added Column -->
        <ng-container matColumnDef="date_added">
          <mat-header-cell *matHeaderCellDef>Рег-ция</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="reg">
                <span
                  matTooltip="{{element.date_added | date: 'dd.MM.yy HH:mm'}}"
                  matTooltipPosition="above">{{ element.date_added | date: 'dd.MM.yy' }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <!-- created_at Column -->
        <ng-container matColumnDef="created_at">
          <mat-header-cell *matHeaderCellDef>Стал рефом</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="active">
                <span
                  matTooltip="{{element.created_at | date: 'dd.MM.yy HH:mm'}}"
                  matTooltipPosition="above"
                >{{ element.created_at | date: 'dd.MM.yy' }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <!-- code Column -->
        <ng-container matColumnDef="code">
          <mat-header-cell *matHeaderCellDef>Код</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.code }}</mat-cell>
        </ng-container>

        <!-- ip Column -->
        <ng-container matColumnDef="ip">
          <mat-header-cell *matHeaderCellDef>IP</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="text-overflow"><a [routerLink]="['/user/check/ip', element.ip]">{{ element.ip }}</a></span>
          </mat-cell>
        </ng-container>

        <!-- bonus_points Column -->
        <ng-container matColumnDef="bonus_points">
          <mat-header-cell *matHeaderCellDef>Баланс</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element.bonus_points | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast">
                     {{ element.bonus_points / 100  | number }}
              </span></mat-cell>
        </ng-container>

        <!-- deposit Column -->
        <ng-container matColumnDef="deposit_total">
          <mat-header-cell *matHeaderCellDef>Деп.</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element?.deposit_total | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast"
              >{{ element.deposit_total / 100 || 0 }}
              </span>
          </mat-cell>
        </ng-container>


        <!-- deposit_count Column -->
        <ng-container matColumnDef="deposit_count">
          <mat-header-cell *matHeaderCellDef>Кол-во</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.deposit_count }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="payouts_total">
          <mat-header-cell *matHeaderCellDef>Выв.</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element?.payouts_total | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast">
                {{ element.payouts_total / 100 || 0 }}
              </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="payouts_count">
          <mat-header-cell *matHeaderCellDef>Кол-во</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.payouts_count }}</mat-cell>
        </ng-container>

        <!-- total_reward_coins Column -->
        <ng-container matColumnDef="total_reward_coins">
          <mat-header-cell *matHeaderCellDef>
              <span
                matTooltip="Уже начисленный доход циклов, созданных в выбранном периоде. Доход относится к дате создания цикла, независимо от даты последующего начисления."
                matTooltipPosition="above">
                Доход за период
              </span>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element?.total_reward_coins  | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast">
                     {{ element.total_reward_coins / 100  | number }}
              </span>
          </mat-cell>
        </ng-container>

        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon (click)="resetReferralIncome(element)">restart_alt</mat-icon>
          </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="referralsColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: referralsColumns;" [ngClass]="row.is_locked?'banned':''">
        </mat-row>

        <div class="empty-data" *matNoDataRow>
          <p *ngIf="!listLoading && !listError">Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="listLoading"></mat-progress-bar>
      <mat-paginator [length]="referralsTotal" [pageIndex]="pageIndex" [pageSize]="pageSize"
                     [pageSizeOptions]="[10, 20, 50, 100]" [disabled]="listLoading"
                     (page)="changePage($event)"></mat-paginator>
    </div>
  </div>
</div>

